import { render, staticRenderFns } from "./ArticleCustomView.vue?vue&type=template&id=3547fcb5&scoped=true&"
import script from "./ArticleCustomView.vue?vue&type=script&lang=js&"
export * from "./ArticleCustomView.vue?vue&type=script&lang=js&"
import style0 from "./ArticleCustomView.vue?vue&type=style&index=0&id=3547fcb5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3547fcb5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
